<ng-container *ngIf="initialized">
  <form class="form" (ngSubmit)="onSave()" #myForm="ngForm" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Resolve CEUs</h5>
      </div>
      <div class="modal-body">
        <div *ngIf="courseEvent.participationModality.toString() == ParticipationModality[ParticipationModality.LiveStream].toString()">
          <div class="d-block"><strong>Participation Modality: Online</strong></div>
          <div class="d-block"><strong>CEU Types: </strong>{{ courseEvent.ceus | ceuDisplay }}</div>
          <div class="row mt-2">
            <ng-container *ngIf="courseEvent.numberOfTokensSet >= 3">
              <div class="alert alert-success col-md-12">You met criteria for this presentation. No further action is required.</div>
              <div class="col-md-12">
                <div class="panel panel-success">
                  <div class="panel-heading">
                    <h5 class="ceu-title ng-star-inserted">Attendance Checks</h5>
                  </div>
                  <div class="panel-body ceu-info-number">{{ courseEvent.numberOfTokensSet }}/4</div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="courseEvent.numberOfTokensSet < 3">
              <div class="alert alert-danger col-md-12">You got {{ courseEvent.numberOfTokensSet }} attendance checks out of 4. You did not meet criteria for this presentation.</div>
              <div class="col-md-12 ng-star-inserted">
                <div class="panel panel-danger">
                  <div class="panel-heading"><h5 class="ceu-title">Attendance Checks</h5></div>
                  <div class="panel-body ceu-info-number">{{ courseEvent.numberOfTokensSet }}/4</div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div *ngIf="courseEvent.participationModality.toString() == ParticipationModality[ParticipationModality.InPerson].toString()">
          <div class="d-block"><strong>Participation Modality: In Person</strong></div>
          <div class="d-block"><strong>CEU Types: </strong>{{ courseEvent.ceus | ceuDisplay }}</div>
          <div class="d-block"><strong>Event Start Time: </strong>{{ courseEvent.originalAirDate | date: 'short' }}</div>
          <div class="d-block"><strong>Event End Time: </strong>{{ courseEvent.originalAirDateEndTime | date: 'short' }}</div>
          <div class="row mt-2">
            <div *ngIf="!courseEvent.ceuCheckins.checkInValid || !courseEvent.ceuCheckins.checkOutValid" class="alert alert-danger col-md-12">Your check-in and check-out times were not within the required thresholds.</div>

            <ng-container>
              <div class="col-md-6">
                <div class="panel" [ngClass]="{ 'panel-success': courseEvent.ceuCheckins.checkInValid, 'panel-danger': !courseEvent.ceuCheckins.checkInValid }">
                  <div class="panel-heading">
                    <h5 class="ceu-title ng-star-inserted">Check-In</h5>
                  </div>
                  <div *ngIf="courseEvent.ceuCheckins.checkInTime" class="panel-body ceu-info-number">{{ courseEvent.ceuCheckins.checkInTime | date: 'short' }}</div>
                  <div *ngIf="!courseEvent.ceuCheckins.checkInTime" class="panel-body ceu-info-number">N/A</div>
                </div>
              </div>
            </ng-container>
            <ng-container>
              <div class="col-md-6 ng-star-inserted">
                <div class="panel" [ngClass]="{ 'panel-success': courseEvent.ceuCheckins.checkOutValid, 'panel-danger': !courseEvent.ceuCheckins.checkOutValid }">
                  <div class="panel-heading"><h5 class="ceu-title">Check-Out</h5></div>
                  <div *ngIf="courseEvent.ceuCheckins.checkOutTime" class="panel-body ceu-info-number">{{ courseEvent.ceuCheckins.checkOutTime | date: 'short' }}</div>
                  <div *ngIf="!courseEvent.ceuCheckins.checkOutTime" class="panel-body ceu-info-number">N/A</div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div *ngIf="courseEvent.participationModality.toString() == ParticipationModality[ParticipationModality.OnDemand].toString()">
          <div class="d-block"><strong>Participation Modality: On-Demand</strong></div>
          <div class="alert alert-warning">It looks like you watched this event, but forgot to take the quiz.</div>
        </div>

        <div *ngIf="courseEvent.assessmentId && !courseEvent.metCEUCriteria">
          <h6 *ngIf="resolve == false && courseEvent.participationModality.toString() != ParticipationModality[ParticipationModality.OnDemand].toString()">This organization allows CEUs to be resolved with a quiz. Would you like to do that now?</h6>
          <div *ngIf="resolve == false" class="text-center"><button type="button" class="btn btn-sm btn-admin-primary" (click)="resolve = true">Resolve</button></div>

          <div *ngIf="resolve">
            <div class="mt-2" *ngFor="let question of assessment.questions; let idx = index">
              <input type="hidden" [(ngModel)]="selectedAnswers.responses[idx].questionId" [value]="5" name="questionId{{ idx }}" />

              <h6>
                <strong>Question {{ idx + 1 }}: {{ question.text }}</strong>
              </h6>
              <div class="ml-3 form-check" *ngFor="let answer of question.answers; let idx2 = index">
                <input class="form-check-input" [(ngModel)]="selectedAnswers.responses[idx].answerId" type="radio" name="question{{ idx }}" [value]="answer.id" />
                <label class="form-check-label">
                  {{ answer.text }}
                </label>
              </div>
            </div>
            <div *ngIf="errorMessage" class="alert alert-danger col-md-12 mb-1">{{ errorMessage }}</div>
            <button type="submit" class="btn btn-admin-primary btn-block">Resolve Event</button>
          </div>
        </div>
        <div *ngIf="!courseEvent.assessmentId && !courseEvent.metCEUCriteria">
          <h6>This organization allows CEUs to be resolved with a quiz, but the presenter(s) haven't provided one yet. Please check back later.</h6>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-outline-dark mr-2" type="button" (click)="done()">
              <span>Cancel</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
